import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CropWiseCommonInformation from "../components/CropWiseCommonInformation";


const CropWiseCommonInformationPage = () => {
  return (
    <>

      {/* <MasterLayout> */}
        <Breadcrumb title="Crop Wise Common Information" />
        <CropWiseCommonInformation />

      {/* </MasterLayout> */}

    </>
  );
};

export default CropWiseCommonInformationPage; 
